import axios from "axios";

const apiOrigin = import.meta.env.VITE_API_BASE_URL || "http://localhost:3001";

// Full API base (origin + /api) for non-axios consumers like the static-map iframe.
export const apiBaseURL = `${apiOrigin}/api`;

// The axios instance's base is the origin only; the generated client's paths
// already include the /api prefix.
export const axiosClient = axios.create({
  baseURL: apiOrigin,
});

// ============================================================================
// JWT Token Helpers
// ============================================================================
const getJWTToken = () => {
  return localStorage.getItem("access_token");
};

// ============================================================================
// Request Interceptor: attach the JWT
// ============================================================================
axiosClient.interceptors.request.use((config) => {
  const token = getJWTToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// ============================================================================
// Response Interceptor: on 401, clear the token and send to login
// ============================================================================
axiosClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem("access_token");
      window.location.href = "/login";
    }
    return Promise.reject(error);
  },
);
